export const Permissions = {
    ACCESS_APPLICATION: "ACCESS_APPLICATION",
    CREATE_TICKET: "CREATE_TICKET",
    VIEW_CLIENT: "VIEW_CLIENT",
    ADMINISTER: "ADMINISTER",
    VIEW_PRODUCT: "VIEW_PRODUCT",
    VIEW_EXPERT_REVIEW: "VIEW_EXPERT_REVIEW",
    VIEW_EXPERT_REVIEW_ADMIN: "VIEW_EXPERT_REVIEW_ADMIN",
    VIEW_FILED_RETURN: "VIEW_FILED_RETURN",
    MODIFY_CONVERSATION: "MODIFY_CONVERSATION",
    VIEW_FILED_RETURN_MODEL: "VIEW_FILED_RETURN_MODEL",
    VIEW_TICKET: "VIEW_TICKET",
    EDIT_TICKET: "EDIT_TICKET",
    DELETE_TICKET: "DELETE_TICKET",
    VIEW_DOCUMENTS: "VIEW_DOCUMENTS",
    EDIT_DOCUMENTS: "EDIT_DOCUMENTS",
    READ_CONVERSATION: "READ_CONVERSATION",
    VIEW_MANAGE_TAB: "VIEW_MANAGE_TAB",
    ASSIGN_TICKET: "ASSIGN_TICKET",
    VIEW_ALL_QUEUES: "VIEW_ALL_QUEUES",
    VIEW_DISTRICT_QUEUES: "VIEW_DISTRICT_QUEUES",
    VIEW_DISTRICT_OFFICES: "VIEW_DISTRICT_OFFICES",
    VIEW_OFFICE_EMPLOYEES: "VIEW_OFFICE_EMPLOYEES",
    VIEW_ALL_OFFICES: "VIEW_ALL_OFFICES",
    MANAGE_ASSOCIATES: "MANAGE_ASSOCIATES",
    MANAGE_ALL_ASSOCIATES: "MANAGE_ALL_ASSOCIATES"
}